import axiosConfig from '../config/axiosBackend'
const urlApi = process.env.REACT_APP_API_INDICADORES
const axios = axiosConfig.iAxios

export const getInfoUsuario = async () => {
    return axios.get(`${urlApi}/api/Usuario/Usuario`)
        .then((res) => { return res.data })
}